/* eslint-disable quotes */
export default {
  internshipBannerData: {
    es: [
      {
        name: "internship",
        imageBanner: "",
        imageDesktopXL: "/assets/images/internship/overhead.svg",
        imageDesktop: "/assets/images/internship/overhead.svg",
        imageMobile: "/assets/images/internship/overhead.svg",
        altImage: "Internships",
        text1: "",
        text2: "",
        text3: "",
        buttonText: "",
        buttonLink: "",
        buttonTarget: "",
      },
    ],
    en: [
      {
        name: "internship",
        imageBanner: "",
        imageDesktopXL: "/assets/images/internship/overhead.svg",
        imageDesktop: "/assets/images/internship/overhead.svg",
        imageMobile: "/assets/images/internship/overhead.svg",
        altImage: "Internships",
        text1: "",
        text2: "",
        text3: "",
        buttonText: "",
        buttonLink: "",
        buttonTarget: "",
      },
    ],
  },
};
